







import { Component } from 'vue-property-decorator'

import Field from './Field.vue'
import DatePicker from '@/components/common/DatePicker.vue'

@Component({
  components: { DatePicker }
})
export default class FieldDate extends Field {
}
